<template>
    <div class="pay-result-confirm">
        <div v-if="!paid" class="pay-waiting-wrapper">
            <img :src="`${$store.state.IMG_HOST}loading_icon@2x.png`">
            <span class="waiting-content">支付结果确认中......</span>
        </div>
        <div v-else class="pay-success-wrapper">
            <div class="left-wrapper">
                <img :src="`${$store.state.IMG_HOST}pay-success-icon@2x.png`">
                <span class="pay-success-text">支付成功</span>
            </div>
            <div class="right-wrapper">
                <span>支付成功！您通过<b>{{ payInstance.payChannelId === 42? '支付宝': '微信支付'}}</b>￥{{ payInstance.amount }}</span>
                <span>订单编号：{{ payInstance.merchantOrderNo }}</span>
                <span><b>{{ countDown }}</b>秒后返回到个人中心</span>
                <router-link :to="{name: 'taskManagementList'}" style="text-decoration: underline; color: #fc5832;">立即返回</router-link>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    export default {
        components: {

        },
        data() {
          return {
            paid: false,
            si: '',
            timer: 0,
            requirementId: '',
            payInstance: {},
            countDown: 10
          }
        },
        methods: {
          init () {
            const that = this;
            const hrefs = document.location.href.split('/');
            that.requirementId = hrefs[hrefs.length-1]
            that.si = setInterval(function() {
                axios.get(`/api/requirement/pay/status/${that.requirementId}`).then( res => {
                  if(res.data.code === 200) {
                    that.paid = res.data.data;
                  }
                });
            }, 2000);
            axios.get(`/api/manager/requirement/${that.requirementId}/order`).then( res => {
              if (res.data.code === 200) {
                that.payInstance = res.data.data;
              } else {
                that.$message({
                  type: 'warning',
                  message: res.data.message,
                  duration: 1500
                });
              }
            });
          }
        },
        watch: {
          paid: function (newValue) {
            const that = this;
            if (newValue) {
              clearInterval(this.si);
              setTimeout( () => {
                that.$router.push({
                    name: 'taskManagementList',
                    query: {subTab: 'mass'}
                });
              }, that.countDown * 1000);
              setInterval( () => {
                that.countDown--
              }, 1000);
            }
          }
        },
        mounted () {
          this.init();
        }
    }

</script>
<style lang="sass">
    @import '../../../sass/copyright/pay/payResultConfirm.scss';
</style>



// WEBPACK FOOTER //
// PayResultConfirm.vue?5ed9a256